import $ from "jquery";
import Snackbar from "./Snackbar";
export default class CopyPageLinkButton {
    static mount() {
        $(function () {
            new CopyPageLinkButton();
        });
    }
    constructor() {
        const $buttons = $('.ce-page-buttons-button--share');
        $buttons.on('click', function () {
            const $this = $(this);
            navigator.clipboard.writeText(window.location.href);
            Snackbar.show($this.data('messagetext'));
        });
    }
}
